import Avatar from '@material-ui/core/Avatar'
import defaultAvatar from 'assets/img/default-avatar.png'
import * as React from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import { isArray } from 'util'
import './style.scss'

export interface INativeQuestionProps {
  iterator: number
  question: string
  answers?: any
  type: string
  preview?: boolean
}
export interface IProps extends INativeQuestionProps, RouteComponentProps {}

class Question extends React.Component<IProps> {
  render() {
    if (this.props.answers || this.props.preview) {
      return (
        <div className="question-content-wrapper">
          <div className="question-wrapper">
            <div className="question-number">{this.props.iterator + 1}.</div>
            <div className="question">{this.props.question}</div>
          </div>
          {this.props.type === 'multiple-choice' ? (
            <div className="answer-list-wrapper">
              {this.props.answers.map((item, i) => {
                return (
                  <div
                    className={`answer-wrapper ${
                      item.images ? 'selected' : ''
                    }`}
                    key={i}
                  >
                    <div className="selected-image-wrapper">
                      {item.images ? (
                        Array.isArray(item.images) ? (
                          item.images.map((img, index) => {
                            return (
                              <Avatar
                                key={index}
                                src={img || defaultAvatar}
                                style={{
                                  marginLeft: index !== 0 ? -7 : 0,
                                  width: 28,
                                  height: 28,
                                  borderRadius: '50%',
                                  backgroundColor: '#fff'
                                }}
                              />
                            )
                          })
                        ) : (
                          <Avatar
                            src={item.images || defaultAvatar}
                            style={{
                              width: 28,
                              height: 28,
                              borderRadius: '50%',
                              backgroundColor: '#fff'
                            }}
                          />
                        )
                      ) : null}
                    </div>
                    {item.answers ? item.answers : item}
                  </div>
                )
              })}
            </div>
          ) : !this.props.preview ? (
            <div className="open-answer-wrapper">
              {this.props.answers.length ? (
                this.props.answers.map((item, index) => {
                  return (
                    <div className="open-answer-images-list" key={index}>
                      {item.images
                        ? item.images.map((avatar, key) => {
                            if (!isArray(avatar)) {
                              return (
                                <div
                                  className="open-answer-list-item"
                                  key={key}
                                >
                                  <Avatar
                                    className="open-answer-image"
                                    src={avatar || defaultAvatar}
                                    key={key}
                                  />
                                  <div className="open-answer">
                                    {item.answers}
                                  </div>
                                </div>
                              )
                            } else {
                              return (
                                <div
                                  className="open-answer-list-item"
                                  key={key}
                                >
                                  {avatar.map((photo, i) => (
                                    <Avatar
                                      className="open-answer-image"
                                      src={photo || defaultAvatar}
                                      key={i}
                                      style={{
                                        marginLeft: i !== 0 ? -10 : 0
                                      }}
                                    />
                                  ))}

                                  <div className="open-answer">
                                    {item.answers}
                                  </div>
                                </div>
                              )
                            }
                          })
                        : null}
                    </div>
                  )
                })
              ) : (
                <div className="answers-empty">No answers</div>
              )}
            </div>
          ) : null}
        </div>
      )
    } else {
      return null
    }
  }
}

const WithRouter = withRouter(Question)

export default (props: INativeQuestionProps) => <WithRouter {...props} />



// WEBPACK FOOTER //
// ./src/components/Question/index.tsx